import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import {
  getNameStateNumberMunicipal,
  IdStateNumberMunicipal,
} from 'civil-status/constants/state-municipal-number';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list: Array<ItemVM> = [
  {
    id: IdStateNumberMunicipal.Disponibile,
    value: getNameStateNumberMunicipal(IdStateNumberMunicipal.Disponibile),
  },
  {
    id: IdStateNumberMunicipal.Utilizzato,
    value: getNameStateNumberMunicipal(IdStateNumberMunicipal.Utilizzato),
  },
  {
    id: IdStateNumberMunicipal.Scartato,
    value: getNameStateNumberMunicipal(IdStateNumberMunicipal.Scartato),
  },
  {
    id: IdStateNumberMunicipal.EventoAcquisito,
    value: getNameStateNumberMunicipal(IdStateNumberMunicipal.EventoAcquisito),
  },
];

interface StateListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const StateListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: StateListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="state-list-label">Stato</InputLabel>
      <PmiSelect
        labelId="state-list-label"
        id="state-list"
        name="state-list"
        value={value}
        label="Stato"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StateListComponent.displayName = 'states list component';

const StateList = memo(StateListComponent);

export default StateList as typeof StateListComponent;
